import React, { PureComponent } from 'react';

import classNames from 'classnames';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';

import DropdownClose from './DropdownClose';
import DropdownContext from './DropdownContext';

import './Dropdown.scss';

export default class Dropdown extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    classNameMenu: PropTypes.string,
    classNameToggle: PropTypes.string,
    dropdownToggle: PropTypes.node,
    icon: PropTypes.element,
    onClick: PropTypes.func,
    children: PropTypes.node,
    isOpened: PropTypes.func,
    preventCloseOnDropdownListClick: PropTypes.bool,
    dropdownListFixed: PropTypes.bool,
    dropdownMenuMaxHeight: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ])
  };

  static defaultProps = {
    dropdownMenuMaxHeight: 300
  };

  static Close = DropdownClose;

  state = {
    active: false
  };

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDropdownToggle = debounce(
      this.handleDropdownToggle.bind(this),
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      200
    );
    this.handleFocus = this.handleFocus.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  get classComponent() {
    return classNames('dropdown', this.props.className, {
      'dropdown--active': this.state.active
    });
  }

  get classMenuComponent() {
    return classNames('dropdown__menu', this.props.classNameMenu, {
      'active': this.state.active,
      'dropdown__menu--fixed': this.props.dropdownListFixed
    });
  }

  get classToggleComponent() {
    return classNames(
      'dropdown__toggle btn--effect btn--effect--round',
      this.props.classNameToggle
    );
  }

  get dropdownContext() {
    return {
      actions: {
        closeDropdown: this.handleClose
      }
    };
  }

  handleOpen() {
    if (!this.state.active) {
      const { isOpened } = this.props;
      const active = true;

      this.setState({ active });

      isOpened && isOpened(active);
    }
  }

  handleClose() {
    if (this.state.active) {
      const { isOpened } = this.props;
      const active = false;

      this.setState({ active: false });

      isOpened && isOpened(active);
    }
  }

  handleOutsideClick(e) {
    const clickOutside = this.dropdown && !this.dropdown.contains(e.target);
    const clickOnDropdownList =
      this.dropdownList && this.dropdownList.contains(e.target);
    const shouldCloseDropdown =
      clickOutside ||
      (clickOnDropdownList && !this.props.preventCloseOnDropdownListClick);

    if (shouldCloseDropdown) {
      this.handleClose();
    }
  }

  handleClick(event) {
    event.stopPropagation();
    event.persist();

    this.handleDropdownToggle(event);
  }

  handleFocus(event) {
    event.persist();

    this.handleDropdownToggle(event);
  }

  handleDropdownToggle(event) {
    const { onClick } = this.props;

    event.stopPropagation();
    event.preventDefault();

    onClick && onClick(this.state);

    if (this.state.active) {
      this.handleClose();
    } else {
      this.handleOpen();
    }
  }

  render() {
    const {
      children,
      className,
      classNameMenu,
      classNameToggle,
      dropdownMenuMaxHeight,
      dropdownToggle,
      icon
    } = this.props;

    const classComponent = classNames('dropdown', className, {
      'dropdown--active': this.state.active
    });
    const classMenuComponent = classNames('dropdown__menu', classNameMenu, {
      active: this.state.active
    });
    const classToggleComponent = classNames(
      'dropdown__toggle btn--effect btn--effect--round',
      classNameToggle
    );

    return (
      <DropdownContext.Provider value={this.dropdownContext}>
        <div className={classComponent} ref={(node) => (this.dropdown = node)}>
          <div
            className={classToggleComponent}
            data-toggle="dropdown"
            onClick={this.handleClick}
            onFocus={this.handleFocus}
            data-test="dropdown-toggle"
          >
            <span className="dropdown-toggle-wrapper">{dropdownToggle}</span>

            {icon}
          </div>

          <ul
            ref={(node) => (this.dropdownList = node)}
            className={classMenuComponent}
            style={{ maxHeight: dropdownMenuMaxHeight }}
          >
            {children}
          </ul>
        </div>
      </DropdownContext.Provider>
    );
  }
}
